export const TreeViewConstants = {
  Keys: {
    Workflow: 'Workflow-Tree-View-Key',
    Configuration: 'Configuration-Tree-View-Key',
    Tools: 'Tools-Tree-View-Key'
  }
};
